import { gql } from '@apollo/client'
import { useContext } from 'react'

import { BoxLockContext } from '../context'
import { PaywallLock } from '../paywall-lock'
import {
  DynamicMultipleOffersSwitchFrequencyLock_OfferLockDataFragment,
  DynamicMultipleOffersSwitchFrequencyLock_ViewerFragment,
} from './__generated__/dynamic-multiple-offers-switch-frequency-lock.graphql'
import { DynamicMultipleOffersSwitchFrequencyLockContent, ModalLock } from './components'

export interface DynamicMultipleOffersSwitchFrequencyLockProps {
  offerLockData: DynamicMultipleOffersSwitchFrequencyLock_OfferLockDataFragment
  viewer: DynamicMultipleOffersSwitchFrequencyLock_ViewerFragment
}

export const DynamicMultipleOffersSwitchFrequencyLock = ({
  offerLockData,
  viewer,
}: DynamicMultipleOffersSwitchFrequencyLockProps) => {
  const { componentType } = useContext(BoxLockContext)
  const isPaywall = componentType === 'paywall'

  const content = (
    <DynamicMultipleOffersSwitchFrequencyLockContent
      offerLockData={offerLockData}
      viewer={viewer}
      isPaywall={isPaywall}
    />
  )

  switch (componentType) {
    case 'paywall':
      return <PaywallLock offerLockData={offerLockData}>{content}</PaywallLock>
    case 'modal':
      return <ModalLock offerLockData={offerLockData}>{content}</ModalLock>
    default:
      return null
  }
}

DynamicMultipleOffersSwitchFrequencyLock.fragments = {
  offerLockData: gql`
    fragment DynamicMultipleOffersSwitchFrequencyLock_offerLockData on OfferLockData {
      ...PaywallLock_offerLockData
      ...ModalLock_offerLockData
      ...DynamicMultipleOffersSwitchFrequencyLockContent_offerLockData
    }
    ${PaywallLock.fragments.offerLockData}
    ${ModalLock.fragments.offerLockData}
    ${DynamicMultipleOffersSwitchFrequencyLockContent.fragments.offerLockData}
  `,
  viewer: gql`
    fragment DynamicMultipleOffersSwitchFrequencyLock_viewer on Profile {
      ...DynamicMultipleOffersSwitchFrequencyLockContent_viewer
    }
    ${DynamicMultipleOffersSwitchFrequencyLockContent.fragments.viewer}
  `,
}
